import { Component, EventEmitter, Input, Output, SimpleChanges } from '@angular/core';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AppConfig } from 'src/app/app.config';
import { WorkshopJobcardEditCustomerComponent } from '../workshop-jobcard-customer-details/workshop-jobcard-edit-customer/workshop-jobcard-edit-customer.component';
import { WorkshopJobcardBookingDetailsModalComponent } from '../workshop-jobcard-booking-details-modal/workshop-jobcard-booking-details-modal.component';
import { HelpersService } from 'src/app/services/helpers.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-workshop-jobcard-header',
  templateUrl: './workshop-jobcard-header.component.html',
  styleUrls: ['./workshop-jobcard-header.component.scss']
})
export class WorkshopJobcardHeaderComponent {

  @Input() activeModal: NgbActiveModal;
  @Input() jobcard: any;
  @Input() jobCards: any = [];
  @Input() originalJobcard: any;
  @Input() preServiceChecklist: any = [];
  @Input() originalPreServiceChecklist: any = [];
  @Output() jobcardChange = new EventEmitter<any>();
  @Output() formReset = new EventEmitter<any>();

  public activeIconColor = 'var(--hubtiger-primary)';
  public inactiveIconColor = '#D1D1D1';
  public statusList: any[] = this.appConfig.getStatusList();
  public allowPrinting = false;
  public allowSettings = false;
  public formChanged = false;
  public countryData: any = this.helpersService.getCountryData();


  public isLocked: boolean = false;

  constructor(
    private appConfig: AppConfig,
    private modalService: NgbModal,
    private helpersService: HelpersService,
    private translate: TranslateService
  ) {
    
  }

  ngOnInit() {
    this.isLocked = this.helpersService.isJobcardLocked(this.jobcard);
  }
  ngOnChanges(changes: SimpleChanges) {
    this.isLocked = this.helpersService.isJobcardLocked(this.jobcard);
  }

  hasChanged() {
    if (this.jobcard && this.originalJobcard) {
      return JSON.stringify(this.jobcard) !== JSON.stringify(this.originalJobcard);
    }
    return false;
  }

  resetForm() {
    this.jobcard = JSON.parse(JSON.stringify(this.originalJobcard));
    this.preServiceChecklist = JSON.parse(JSON.stringify(this.originalPreServiceChecklist));
    this.formReset.emit({ jobcard: this.jobcard, preServiceChecklist: this.preServiceChecklist });
  }

  getCustomerName(): string {
    const customer = this.jobcard.customer;
    return customer ? `${customer.Name || ''} ${customer.Surname || ''}` : '';
  }

  getCurrentStatusLabel() {
    var status = this.statusList.find(x => x.key === this.jobcard.statusID);
    return status ? status.label : this.jobcard.statusID === 100 ? this.translate.instant('bikeshop.statuses.cancelled') : 'Unknown Status';
  }

  getServiceTypesLabel() {
    return this.jobcard.selectedServiceTypes?.map((st: any) => st.serviceType).join(', ');
  }

  updateCustomer() {
    const modalRef = this.modalService.open(WorkshopJobcardEditCustomerComponent, {
      backdrop: true,
      backdropClass: 'jobcard-modal-popup-backdrop',
      windowClass: 'jobcard-modal-popup-window',
      size: 'xl'
    });

    modalRef.componentInstance.jobcard = this.jobcard;
    modalRef.componentInstance.customer = this.jobcard.customer;

    modalRef.result.then(
      (result) => {
        if (result.customer && result.customer.ID) {
          this.jobcard.customer = result.customer;
        }
      },
      (onrejected) => {
        console.log('Modal dismissed:', onrejected);
      },
    );
  }

  openBookingDetails() {
    const modalRef = this.modalService.open(WorkshopJobcardBookingDetailsModalComponent, {
      backdrop: true,
      backdropClass: 'jobcard-modal-popup-backdrop',
      windowClass: 'jobcard-modal-popup-window',
      size: 'lg'
    });

    modalRef.componentInstance.jobcard = JSON.parse(JSON.stringify(this.jobcard));
    modalRef.componentInstance.jobcardChange.subscribe((event: any) => {
      console.log('Received jobcardChange event:', event);
      this.jobcard = event;
      this.jobcardChange.emit({...this.jobcard});
    });

    modalRef.result.then(
      (result) => {

      },
      (onrejected) => {
        console.log('Modal dismissed:', onrejected);
      },
    );
  }

}
